import React from 'react'
import { FiEdit3 as EditIcon } from 'react-icons/fi'
import { Button } from 'react-bootstrap'
import PaymentIcon from 'src/views/components/PaymentIcon'
import { i18nTranslate } from 'src/utils'

class ShippingDetailsCard extends React.Component {
  renderDetails = () => {
    const { details = {}, isToDisableEditButton = false } = this.props
    const testId = `qa-subscription-${details.isFrom}-edit`
    const line1TestId = `qa-subscription-${details.isFrom}-line1`
    const line2TestId = `qa-subscription-${details.isFrom}-line2`
    const line3TestId = `qa-subscription-${details.isFrom}-line3`
    const aria = `${details.heading} edit button`
    return (
      <div className="details-section">
        <div className="heading-wrapper d-flex justify-content-between">
          <h5 className="details-heading mb-2 subs-secondary-title">
            {details.heading}
          </h5>
          <Button
            className="details-edit-button"
            variant="black"
            // data-testid={testId}
            disabled={isToDisableEditButton}
            onClick={details.event}>
            <EditIcon aria-label={aria} tabIndex={0} data-testid={testId} />
          </Button>
        </div>
        <div className="d-flex">
          {details.cardType && (
            <div className="pr-2">
              <PaymentIcon type={details.cardType?.toLowerCase()} />
            </div>
          )}
          <div className="d-flex flex-column shipping-details-text">
            {details.line1 && (
              <span className="m-0 line1" data-testid={line1TestId}>
                {details.line1}
              </span>
            )}
            {details.line2 && (
              <span className="m-0 line2" data-testid={line2TestId}>
                {details.line2}
              </span>
            )}
            {details.line3 && (
              <span className="m-0 line3" data-testid={line3TestId}>
                {details.line3}
              </span>
            )}
            {details.shippingInstruction && (
              <span className="m-0">
                {i18nTranslate(
                  'shippingInstructions',
                  'Shipping instructions',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}
                : {details.shippingInstruction}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
  render() {
    return (
      <div className="shipping-details-section">{this.renderDetails()}</div>
    )
  }
}
export default ShippingDetailsCard
export { ShippingDetailsCard }
